import { oneOf } from 'prop-types'
import { CustomCouplingRuleTypeEnum } from '../../models/vehicle/custom-coupling-rule-type-enum'

/**
 * @readonly
 * @typedef {string} customCouplingRule
 * List of all configured custom coupling rules with specific configuration (coupling to force or to ignore ) for a
 * given account.
 */
export const customCouplingRuleTypePropType = oneOf(Object.values(CustomCouplingRuleTypeEnum))
